import React from 'react';

function withActiveMenuItem(WrappedComponent: any) {
  // eslint-disable-next-line react/display-name
  return class extends React.Component<any> {
    // eslint-disable-next-line class-methods-use-this
    isMenuItemActive(destHref: string) {
      const { isHomeRoute = false } = this.props;
      try {
        const currentHref = window.location.href;
        const currentUrl = new URL(currentHref);
        const relativeCurrentHref = currentHref.replace(
          currentUrl.origin.toString(),
          '',
        );
        const isHomeRouteActive = isHomeRoute && relativeCurrentHref === '/';
        return isHomeRouteActive || relativeCurrentHref.includes(destHref);
      } catch (_) {
        return false;
      }
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          active={this.isMenuItemActive(this.props.to)}
        />
      );
    }
  };
}

export default withActiveMenuItem;
